import script from "./CompanionHotspots.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionHotspots.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionHotspots.vue?vue&type=style&index=0&id=a4d2e7c8&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4d2e7c8"]])

export default __exports__